'use strict';

class CardFilters {

	/**
	 * Constructor method
	 */
	constructor() {

		// ParentNode.prepend() polyfill for IE(11)
		this.polyfillIEPrepend();

		// Cache variables for later use
		this.filter_parents = document.querySelectorAll('.js-card-filters-parent');

	}

	/**
	 * Init method
	 */
	init() {

		// Bail out early if no card filter parents found.
		if (!this.filter_parents.length) {
			// Trigger the init done event in case some third party is waiting for this to happen.
			document.dispatchEvent(new CustomEvent('cardfilters-init-done'));
			return;
		}

		// Iterate over filter parents.
		this.filter_parents.forEach(filterParent => {

			// Placeholders for years and tags
			const cardsByYear = {};
			const cardsByTag = {};

			// Find and process filter items.
			const filterItems = {};
			filterParent.querySelectorAll('.js-card-filters-child[data-card-filters]').forEach(item => {
				const id = item.getAttribute('id');
				const data = JSON.parse(item.getAttribute('data-card-filters'));
				if (data.year) {
					if (!Object.prototype.hasOwnProperty.call(cardsByYear, data.year)) {
						cardsByYear[data.year] = [];
					}
					cardsByYear[data.year].push(id);
				}
				if (data.tags) {
					data.tags = data.tags.split('|');
					data.tags.forEach(tag => {
						if (!Object.prototype.hasOwnProperty.call(cardsByTag, tag)) {
							cardsByTag[tag] = [];
						}
						cardsByTag[tag].push(id);
					});
				}
				filterItems[id] = data;
			});

			// Render filter container.
			let filterContainer = null;
			if (Object.keys(cardsByYear).length || Object.keys(cardsByTag).length) {
				filterContainer = document.createElement('form');
				filterContainer.classList.add('container');
				filterContainer.classList.add('text-center');
				filterContainer.classList.add('py-single');
				filterParent.prepend(filterContainer);
			}

			// Render year filters.
			if (Object.keys(cardsByYear).length) {
				filterContainer.appendChild(this.getFilterInput(
					filterParent,
					'cards-by-year',
					filterParent.getAttribute('data-card-filters-label-year'),
					cardsByYear
				));
			}

			// Render tag filters.
			if (Object.keys(cardsByTag).length) {
				filterContainer.appendChild(this.getFilterInput(
					filterParent,
					'cards-by-tag',
					filterParent.getAttribute('data-card-filters-label-tags'),
					cardsByTag
				));
			}

		});

	}

	/**
	 * Create HTML elements for a filter input
	 *
	 * @param {HTMLElement} filterParent Filter parent.
	 * @param {string} name Name for the filter input.
	 * @param {string} text Text for the filter input label.
	 * @param {Object} cards Object containing filterable cards.
	 * @returns {HTMLElement} HTML elements for the filter input.
	 */
	getFilterInput(filterParent, name, text, cards) {

		// Create label
		const label = document.createElement('label');
		label.classList.add('p-single');
		label.classList.add('mx-single');
		label.classList.add('mb-single');
		label.classList.add('inline-block');
		label.classList.add('relative');
		label.classList.add('w-64');
		label.classList.add('text-left');

		// Create label text
		const labelText = document.createElement('span');
		labelText.classList.add('inline-block');
		labelText.classList.add('pb-2');
		labelText.classList.add('uppercase');
		labelText.classList.add('text-sm');
		labelText.classList.add('font-bold');
		labelText.classList.add('pl-4');
		labelText.classList.add('text-gray-600');
		labelText.textContent = text;
		label.appendChild(labelText);

		// Create wrapper
		const wrapper = document.createElement('div');
		wrapper.classList.add('inline-block');
		wrapper.classList.add('relative');
		wrapper.classList.add('w-64');
		label.appendChild(wrapper);

		// Create select
		const select = document.createElement('select');
		select.classList.add('block');
		select.classList.add('appearance-none');
		select.classList.add('ie-appearance-none');
		select.classList.add('w-full');
		select.classList.add('bg-white');
		select.classList.add('border');
		select.classList.add('border-gray-400');
		select.classList.add('hover:border-gray-500');
		select.classList.add('focus:border-gray-500');
		select.classList.add('px-4');
		select.classList.add('py-2');
		select.classList.add('pr-8');
		select.classList.add('rounded');
		select.classList.add('shadow');
		select.classList.add('leading-tight');
		select.classList.add('focus:outline-none');
		select.classList.add('focus:shadow-outline');
		select.name = name;
		select.addEventListener('change', () => {
			label.parentNode.querySelectorAll('select:not([name="' + select.name + '"])').forEach(otherSelect => {
				otherSelect.selectedIndex = 0;
			});
			filterParent.querySelectorAll('.js-card-filters-child').forEach(child => {
				if (select.selectedIndex === 0) {
					child.classList.remove('hidden');
				} else {
					if (cards[select.value].indexOf(child.id) === -1) {
						child.classList.add('hidden');
					} else {
						child.classList.remove('hidden');
					}
				}
			});
		});
		wrapper.appendChild(select);

		// Create icon container
		const iconContainer = document.createElement('div');
		iconContainer.classList.add('pointer-events-none');
		iconContainer.classList.add('absolute');
		iconContainer.classList.add('inset-y-0');
		iconContainer.classList.add('right-0');
		iconContainer.classList.add('flex');
		iconContainer.classList.add('items-center');
		iconContainer.classList.add('px-2');
		iconContainer.classList.add('text-gray-700');
		wrapper.appendChild(iconContainer);

		// Create icon
		const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		icon.setAttributeNS(null, 'class', 'fill-current h-4 w-4');
		icon.setAttributeNS(null, 'viewBox', '0 0 20 20');
		const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
		path.setAttributeNS(null, 'd', 'M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z');
		icon.appendChild(path);
		iconContainer.appendChild(icon);

		// Append options
		let options = Object.keys(cards).sort();
		if (name == 'cards-by-year') {
			options = options.reverse();
		}
		options.unshift('Kaikki');
		this.addOptions(select, options);

		return label;
	}

	/**
	 * Add option elements to select element
	 *
	 * @param {HTMLElement} select Select element.
	 * @param {Array} items Array of items.
	 */
	addOptions(select, items) {
		items.forEach(value => {
			const option = document.createElement('option');
			option.value = value;
			option.innerHTML = value;
			select.appendChild(option);
		});
	}

	/**
	 * Provide polyfill for ParentNode.prepend() in IE(11)
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/prepend
	 */
	polyfillIEPrepend() {
		// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/prepend()/prepend().md
		(function (arr) {
			arr.forEach(function (item) {
				if (Object.prototype.hasOwnProperty.call(item, 'prepend')) {
					return;
				}
				Object.defineProperty(item, 'prepend', {
					configurable: true,
					enumerable: true,
					writable: true,
					value: function prepend() {
						var argArr = Array.prototype.slice.call(arguments),
							docFrag = document.createDocumentFragment();
						
						argArr.forEach(function (argItem) {
							var isNode = argItem instanceof Node;
							docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
						});
						
						this.insertBefore(docFrag, this.firstChild);
					}
				});
			});
		})([Element.prototype, Document.prototype, DocumentFragment.prototype]);
	}

}